import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { NLGroupChat } from "@/components/your-voters/NLGroupChat";
import { VoterFileBrowser } from "@/components/voter-file/VoterFileBrowser";
import { useSession } from "@/hooks/use-session";
import { apiService } from "@/lib/api-service";

export const Route = createFileRoute("/_app/_/your-voters")({
	component: YourVotersPage,
});

function YourVotersPage() {
	const contextSession = useSession();
	// Always refetch the session on this page so voter_file_access reflects
	// the latest admin toggle + impersonation state.
	const { data: freshSession } = useQuery({
		queryKey: ["session"],
		queryFn: () => apiService.getSession(),
		refetchOnMount: "always",
	});
	const session = freshSession ?? contextSession;
	const campaignId = session?.campaign?.id;
	const campaign = session?.campaign;
	const hasVoterFileAccess = campaign?.voter_file_access ?? false;

	if (!campaignId) {
		return (
			<div className="flex h-full items-center justify-center text-muted-foreground">
				No campaign selected
			</div>
		);
	}

	const lockedScope = {
		state: campaign?.voter_file_state ?? null,
		congressional_district: campaign?.voter_file_congressional_district ?? null,
		state_senate_district: campaign?.voter_file_state_senate_district ?? null,
		state_house_district: campaign?.voter_file_state_house_district ?? null,
		county: campaign?.voter_file_county ?? null,
		county_fips: campaign?.voter_file_county_fips ?? null,
		city: campaign?.voter_file_city ?? null,
		school_district: campaign?.voter_file_school_district ?? null,
	};

	if (!hasVoterFileAccess) {
		return (
			<div className="h-[calc(100vh-4rem)]">
				<NLGroupChat campaignId={campaignId} />
			</div>
		);
	}

	return (
		<div className="h-[calc(100vh-4rem)] overflow-auto">
			<VoterFileBrowser
				campaignId={campaignId}
				lockedScope={lockedScope}
			/>
		</div>
	);
}
